module.exports = __webpack_public_path__ + "img/wenjiang4.a5097609.png";